import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { formSubmissionSlug as formSubmissionSlugSelector } from "reduxSlices/formSubmissionSlice"
import {
  refresh as refreshConversations,
  loading as conversationsLoading,
} from "reduxSlices/formSubmissionConversationsSlice"
import {
  initialize as initializeResolution,
  loading as resolutionLoading,
} from "reduxSlices/formSubmissionResolutionSlice"
import ContentHeader from "shared/ContentHeader"
import LoadingIndicator from "shared/LoadingIndicator"
import ConversationsSection from "./ConversationsSection"
import ResolutionSection from "./ResolutionSection"

export const CONVERSATIONS_TAB_ID = "tab-conversations"
export const CONVERSATIONS_TAB_PANEL_ID = "tabpanel-conversations"

const ConversationsContent = () => {
  const dispatch = useDispatch()

  const formSubmissionSlug = useSelector(formSubmissionSlugSelector)
  const loadingConversations = useSelector(conversationsLoading)
  const loadingResolution = useSelector(resolutionLoading)

  // Load the form submission's resolution when the component mounts
  useEffect(() => {
    dispatch(initializeResolution({ formSubmissionSlug }))
  }, [dispatch, formSubmissionSlug])

  // Refresh conversations when the tab mounts. The slice is expected to already be
  // initialized when the form submission page loads, so this fetches the latest data.
  useEffect(() => {
    dispatch(refreshConversations())
  }, [dispatch])

  return (
    <div id={CONVERSATIONS_TAB_PANEL_ID} className="relative grow" role="tabpanel" aria-labelledby={CONVERSATIONS_TAB_ID}>
      <div className="inner-container mx-auto max-w-screen-lg">
        <ContentHeader
          heading={
            <h2 className="header-title">Conversations</h2>
          }
        />
        {
          (loadingConversations || loadingResolution)
            ? (
              <LoadingIndicator textValue="Loading ..." />
            )
            : (
              <div className="flex flex-col gap-12">
                <ConversationsSection />
                <ResolutionSection />
              </div>
            )
        }
      </div>
    </div>
  )
}

export default ConversationsContent
